/// <reference path="../../../typings/browser.d.ts" />


namespace Application.Controllers {
    'use strict';

    export interface IMessageTranslationModalScope extends ng.IScope {
        element: Models.IMessageTranslation;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * MessageTranslationModalController class
     */
    export class MessageTranslationModalController {
        public static templateUrl: string = "decorators/modals/message-translation-modal.html";
        public static ID: string = "#id-message-translation-modal";
        public static $name: string = "messageTranslationModal";
        public static $inject: string[] = ['$scope',
            'close',
            'element',
        ];

        private scope: IMessageTranslationModalScope;
        private close: (response: Models.IMessageTranslation) => void;

        /**
         * Constructor
         */
        constructor($scope: IMessageTranslationModalScope,
                    close: () => void,
                    element: Models.IMessageTranslation) {
            this.scope = $scope;
            this.close = close;
            this.scope.element = element;

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.modalSave = (): void => {
                this.close(element);
            };

        }
    }
}
